import { z } from 'zod';
import type { SchemaInput } from './schema-input.js';

const total = z.number().finite().nonnegative();
const point = z.tuple([z.number().int().min(-9_000_000).max(9_000_000), z.number().int().min(-18_000_000).max(18_000_000)]);
export const savedRouteOptionSchema = z.object({
    distanceKm: total,
    durationSec: total,
    legDistancesKm: z.array(total).min(1).max(499),
    viaLabel: z.string().max(1000),
    hasFerry: z.boolean(),
    coords: z.array(z.tuple([z.number().finite().min(-180).max(180), z.number().finite().min(-90).max(90)])).min(2).max(100_000),
    steps: z.array(z.object({
      instruction: z.string().max(2000), distanceM: total, durationSec: total,
      travelMode: z.enum(['driving', 'ferry']),
    })).max(10_000),
});
export const savedRouteSchema = z.object({
  version: z.literal(1),
  mode: z.enum(['driving', 'walking', 'cycling']),
  points: z.array(point).min(2).max(500),
  addresses: z.array(z.string().max(1000)).max(500),
  route: savedRouteOptionSchema,
}).refine(value => value.addresses.length === value.points.length && value.route.legDistancesKm.length === value.points.length - 1);

export type SavedRoute = z.infer<typeof savedRouteSchema>;

/** Accept a route only for the exact ordered stops and travel mode that produced it. */
export function readMatchingSavedRoute(value: SchemaInput, points: ReadonlyArray<readonly number[]>, mode: string): SavedRoute | null {
  const parsed = savedRouteSchema.safeParse(value);
  if (!parsed.success || parsed.data.mode !== mode || parsed.data.points.length !== points.length) return null;
  return parsed.data.points.every((point, index) => point[0] === points[index][0] && point[1] === points[index][1]) ? parsed.data : null;
}
